import { defineComponent as _defineComponent } from 'vue'
import newContent from '@/components/newContent.vue'


type PropsType = {
  label: string
  width?: string
  isShowNew?: boolean
  styleObj?: object
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-setting-content',
  props: {
    label: null,
    width: null,
    isShowNew: { type: Boolean, default: false },
    styleObj: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { label: string, width?: string, isShowNew: boolean, styleObj: object }



return { __sfc: true,props, newContent }
}

})